import React, { useState } from "react";
import { CheckCircle2, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const ctl = "h-10 px-3 rounded-md border border-input bg-card text-sm focus:outline-none focus:ring-2 focus:ring-ring/40";

// WhatsApp OTP for one mobile; calls onVerified(otpId) once the code is accepted.
export const OtpVerify = ({ role, mobile, otpId, onVerified }) => {
  const [sent, setSent] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const verified = !!otpId && sent?.mobile === mobile;

  const send = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/gatepass/otp/send", { mobile, role });
      setSent({ id: data.otp_id, mobile, channel: data.channel });
      setCode("");
      onVerified("");
      toast.success(`OTP sent by ${data.channel === "sms" ? "SMS" : "WhatsApp"} to ${data.sent_to}`);
    } catch (e) { const m = formatApiError(e.response?.data?.detail); setErr(m); toast.error(m); }
    setBusy(false);
  };
  const verify = async () => {
    try {
      await api.post("/gatepass/otp/verify", { otp_id: sent.id, code });
      onVerified(sent.id);
      toast.success(`${role === "driver" ? "Driver" : "Guarantor"} mobile verified`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (verified) {
    return <div data-testid={`gp-${role}-verified`} className="text-xs font-medium text-[hsl(var(--positive))] flex items-center gap-1"><CheckCircle2 size={13} /> OTP verified</div>;
  }
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" data-testid={`gp-${role}-send-otp`} disabled={busy || (mobile || "").replace(/\D/g, "").length < 10} onClick={send}
        className="h-10 px-3 rounded-md border border-input bg-card text-xs font-medium flex items-center gap-1.5 hover:bg-muted transition-colors disabled:opacity-40">
        <Send size={13} /> {sent ? "Resend OTP" : "Send OTP"}
      </button>
      {sent && sent.mobile === mobile && (
        <>
          <input data-testid={`gp-${role}-otp`} className={`${ctl} w-28 num`} inputMode="numeric" maxLength={6} placeholder="6-digit OTP" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} />
          <button type="button" data-testid={`gp-${role}-verify-otp`} disabled={code.length !== 6} onClick={verify}
            className="h-10 px-3 rounded-md bg-primary text-primary-foreground text-xs font-medium hover:bg-primary/90 transition-colors disabled:opacity-40">Verify</button>
        </>
      )}
      {err && <p data-testid={`gp-${role}-otp-error`} className="basis-full text-xs text-destructive">OTP not sent, so the OTP box can't open yet: {err}</p>}
      {sent && sent.mobile === mobile && <p className="basis-full text-xs text-muted-foreground">Enter the 6-digit code from {sent.channel === "sms" ? "the SMS" : "WhatsApp"}, tap Verify, then Create gate pass.</p>}
    </div>
  );
};
